function initMap(){
  if (document.getElementById('map')){
    var center = {lat: 48.07, lng: -3};
    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 8,
      center: center,
      streetViewControl: false,
      mapTypeControl: false
    });
    var shops = document.querySelectorAll('.shops-map__shop');
    var image = '/themes/kiclos/assets/images/pictos/marker.png';
    /* jshint ignore:start */
    for (var i = 0; i < shops.length; i++){
      var lat = parseFloat(shops[i].getAttribute('data-lat'));
      var lng = parseFloat(shops[i].getAttribute('data-lng'));
      var storeId = parseInt(shops[i].getAttribute('data-id'));
      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map,
        icon: image,
      });
      shops[i].addEventListener('click', function(event){
        var lat = parseFloat(event.currentTarget.getAttribute('data-lat'));
        var lng = parseFloat(event.currentTarget.getAttribute('data-lng'));
        map.panTo({lat: lat, lng: lng});
        window.setTimeout(function(){
          map.setZoom(14);
        }, 400);
        var prevSelected = document.querySelector('.shops-map__shop.m--selected');
        if (prevSelected){
          prevSelected.classList.remove('m--selected');
        }
        event.currentTarget.classList.add('m--selected');
      });
      (function (marker, storeId) {
        google.maps.event.addListener(marker, "click", function () {
          var selectedStore = document.querySelector('.shops-map__shop[data-id="' + storeId + '"]');
          var prevSelected = document.querySelector('.shops-map__shop.m--selected');
          var listContainer = document.querySelector('.shops-map__list');

          listContainer.scrollTop = selectedStore.offsetTop;
          if (prevSelected){
            prevSelected.classList.remove('m--selected');
          }
          selectedStore.classList.add('m--selected');
          map.panTo(this.getPosition());
          map.setZoom(14);
        });
      })(marker, storeId);
    }
    /* jshint ignore:end */
  }
}

jQuery(function($){
  if ($('.shops-map__list').length){
    var ps = new PerfectScrollbar('.shops-map__list');
    $('.markets__group-title').on('click', function() {
      if (!$(this).parent('.markets__group').hasClass('m--active')){
        $('.markets__group.m--active').removeClass('m--active');
        $(this).parent('.markets__group').addClass('m--active');
      }
      else {
        $(this).parent('.markets__group').removeClass('m--active');
      }
    });
  }
});

